import { useExerciseCategoriesQuery } from '@/hooks/query-hooks';
import { Autocomplete, TextField, useTheme } from '@mui/material';

export default function ExerciseCategoryAutocomplete(props: { selectedCategoryIds: Array<string>; setSelectedCategoryIds: (ids: Array<string>) => void }) {
  const { exerciseCategories } = useExerciseCategoriesQuery(true);
  const { selectedCategoryIds, setSelectedCategoryIds } = props;
  const theme = useTheme();

  return (
    <Autocomplete
      multiple
      autoHighlight
      id="tags-outlined"
      value={exerciseCategories?.filter((eq) => selectedCategoryIds.includes(eq.id)) ?? []}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(event, categories) => {
        setSelectedCategoryIds(categories.map((cat) => cat.id));
      }}
      options={exerciseCategories ?? []}
      getOptionLabel={(option) => option.name}
      filterSelectedOptions
      sx={{ minWidth: 200 }}
      slotProps={{ popper: { sx: { zIndex: theme.zIndex.modal + 2 } } }}
      renderInput={(params) => <TextField variant="outlined" {...params} label={`Categories`} placeholder={`Categories`} />}
    />
  );
}
